document.addEventListener('DOMContentLoaded', function() {
  const imageCarouselContainer = document.querySelector('.primgSlider');
  if (!imageCarouselContainer) return;

  // Escucha cualquier input radio dentro del formulario de producto
  // (cubre Color, Sabor, Talla, Flavor y cualquier nombre de opción)
  const variantSelectors = document.querySelectorAll(
    '.product-form input[type="radio"], variant-radios input[type="radio"]'
  );

  variantSelectors.forEach(function(selector) {
    selector.addEventListener('change', function() {
      window.scrollTo({
        top: imageCarouselContainer.offsetTop,
        behavior: 'smooth'
      });
    });
  });
});
